
import { controls } from "../controls";
const recoveryagri = {
  label: "Loan Recovery",
  pageLabel: "Loan Recovery",
  starting: true,
  url: "recoveryagri",
  formActions: { edit: { allow: true } },
  pageType: "history",
  form: [
    ...controls.displayText({ tab: "create", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: "create", placeHolder: "PACS ID", name: "pacs_id", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-1" }),
    ...controls.AccountNumber({ tab: "create" }),
    ...controls.showData({ tab: "create", data: "account_number_display", name: "account_number_display", width: "col-sm-3" }),

    ...controls.displayText({ tab: "create", label: "Member ID", width: "col-sm-1" }),
    ...controls.text({ tab: "create", placeHolder: "Member ID", name: "member_id", width: "col-sm-2" }),


    ...controls.displayText({ tab: "create", label: "Amount", width: "col-sm-1" }),
    ...controls.text({ tab: "create", placeHolder: "", name: "amount", width: "col-sm-2" }),
    // ...controls.displayText({ tab: "create", label: "", width: "col-sm-5" }),

    ...controls.button({
      label: "ADD", style: { padding: 0 },
      Bcolor: "success", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'recovery_table',
        requiredField: ["pacs_id", "account_number", "account_number_display", "member_id", "amount"]
      }, width: "col-sm-1"
    }),

    ...controls.displayText({ tab: "create", label: "", width: "col-sm-5" }),

    ...controls.displayText({ tab: "create", label: "Total Recovered", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", isReadOnly: true, name: "total_recovered_amount", width: "col-sm-2" }),

    {
      inputType: "table",
      tab: "create",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "PACS ID", field: "pacs_id" },
        { label: "Ac No", field: "account_number" },
        { label: "Name", field: "account_number_display" },
        { label: "Member ID", field: "member_id" },
        { label: "Amount", field: "amount", displaytype:"currency" }
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "recovery_table",
      onRender: [
        { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.recovery_table', field: 'amount' }, resultVar: 'totalAmount' },
        // { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalAmount' }, { source: 'pageData.total_recovered_amount' }], resultVar: 'total' },
        { f: 'setParentState', inputs: { dest: "pageData.total_recovered_amount", source: 'allResults', field: 'totalAmount' }, resultVar: "total_recovered_amount" },
      ]

    }
  ]
};

export default recoveryagri;